export default __webpack_public_path__ + "static/media/profile2.cd536c7d.jpg";